import { getProduct, getWebOrderDetails, getWebOrderDiscountsDetails } from "../apis/backendRequests";
import { orderActions } from "../actions";

export async function GetDetailOrder(dynamicsId, webOrderId, dispatch, actions, isCart = false) {
    let orderDetails, discountDetails;
    
    try {
        [orderDetails, discountDetails] = await Promise.all([
            getWebOrderDetails(webOrderId),
            getWebOrderDiscountsDetails(webOrderId)
        ]);
    } catch (error) {
        console.error('Error al obtener detalles de la orden:', error.message || error);
        return { success: false, error };
    }

    if (!orderDetails?.data?.length) {
        console.warn('No se encontraron detalles de la orden');
        return { success: true, products: [] };
    }

    const productsWithDetails = orderDetails.data.map(async (prod) => {
        try {
            const productDetails = await getProduct(prod.productId, dynamicsId); 
            const discount = discountDetails?.data?.find(desc => desc.productId === prod.productId);

            if (productDetails && discount && isCart) {
                return {
                    ...productDetails.data,
                    productDescription: productDetails.data.productDescription,
                    quantity: prod.quantity,
                };
            }

            if (productDetails && discount && !isCart) {
                return {
                    ...prod,
                    productDescription: productDetails.data.productDescription,
                    quantity: prod.quantity,
                    discount: discount
                };
            }

            return null;
        } catch (error) {
            console.warn(`Error al obtener producto ${prod.productId}:`, error.message || error);
            return null;
        }
    });
    
    if (isCart) {
        localStorage.setItem("webOrder", webOrderId)
    }
    const products = (await Promise.all(productsWithDetails)).filter(Boolean);

    products.forEach(product => {
        dispatch(actions.addItem(product));
    });

    return { success: true, products };
}